import { render, staticRenderFns } from "./ShipmentStock.vue?vue&type=template&id=79916c28&"
import script from "./ShipmentStock.vue?vue&type=script&lang=js&"
export * from "./ShipmentStock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ShipmentStock.vue"
export default component.exports